import { render } from "./ComponentCard.vue?vue&type=template&id=779ffbd4&ts=true"
import script from "./ComponentCard.vue?vue&type=script&lang=ts"
export * from "./ComponentCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__